module.exports = __webpack_public_path__ + "img/night-01.494a66e8.jpg";